import gql from "graphql-tag";
import { User } from "../baseTypes";
export default gql`
  query GetCognitoUser($username: ID!) {
    getCognitoUser(username: $username) {
      username
      groups
    }
  }
`;
export interface GetCognitoUserQuery {
  getCognitoUser: User | null;
}
